var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Vue } from 'vue-property-decorator';
import * as yup from 'yup';
var IcbariAutoValidationMixin = /** @class */ (function (_super) {
    __extends(IcbariAutoValidationMixin, _super);
    function IcbariAutoValidationMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(IcbariAutoValidationMixin.prototype, "registrationPlatePattern", {
        get: function () {
            return this.isMoto ? /^\d{2}[A-Z]\d{3}$/ : /^\d{2}[A-Z]{2}\d{3}$/;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IcbariAutoValidationMixin.prototype, "step1ValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step1) || {};
            var shape = {
                registrationPlate: yup
                    .string()
                    .required(t.registration_plate_required || 'Qeydiyyat nişanı tələb olunur')
                    .matches(this.registrationPlatePattern, t.registration_plate_invalid || 'Qeydiyyat nişanı düzgün formatda deyil'),
                certificate: yup
                    .string()
                    .required(t.certificate_required || 'Qeydiyyat şəhadətnaməsi tələb olunur')
                    .matches(/^[A-Z]{2}\d{6,7}$/, t.certificate_invalid || 'Qeydiyyat şəhadətnaməsi düzgün formatda deyil'),
            };
            if (this.showBrandSelection || this.isExtraRequired) {
                shape.make = yup.string().required(t.make_required || 'Marka tələb olunur');
            }
            if (this.showRiskModelSelection || this.isExtraRequired) {
                shape.model = yup.string().required(t.model_required || 'Model tələb olunur');
            }
            if (this.isExtraRequired) {
                shape.vehicleType = yup.string().required(t.vehicle_type_required || 'Nəqliyyat vasitəsinin növü tələb olunur');
            }
            return yup.object().shape(shape);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IcbariAutoValidationMixin.prototype, "step2ValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step2) || {};
            var shape = {
                passport: yup
                    .string()
                    .required(t.passport_required || 'Şəxsiyyət vəsiqəsi tələb olunur')
                    .test('passport-length', t.passport_invalid || 'Şəxsiyyət vəsiqəsi düzgün formatda deyil', function (value) {
                    var _a;
                    if (!value)
                        return true;
                    var docType = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.docType;
                    var expectedLength = docType === 'AZE' ? 8 : 7;
                    var digitsOnly = /^\d+$/.test(value);
                    if (!digitsOnly) {
                        return this.createError({
                            message: t.passport_invalid || 'Şəxsiyyət vəsiqəsi yalnız rəqəmlərdən ibarət olmalıdır'
                        });
                    }
                    if (value.length !== expectedLength) {
                        var message = docType === 'AZE'
                            ? (t.passport_invalid_aze || 'Şəxsiyyət vəsiqəsi 8 rəqəmdən ibarət olmalıdır')
                            : (t.passport_invalid_other || 'Sənəd nömrəsi 7 rəqəmdən ibarət olmalıdır');
                        return this.createError({ message: message });
                    }
                    return true;
                }),
                fin: yup
                    .string()
                    .required(t.fin_required || 'FIN kod tələb olunur')
                    .length(7, t.fin_invalid || 'FIN kod 7 simvoldan ibarət olmalıdır'),
                drivingLicense: yup
                    .string()
                    .optional()
                    .test('driving-license-format', t.driving_license_invalid || 'Sürücülük vəsiqəsi düzgün formatda deyil', function (value) {
                    if (!value)
                        return true;
                    return /^[A-Z]{2}\d{6}$/.test(value);
                }),
                phone: yup
                    .string()
                    .required(t.phone_required || 'Telefon nömrəsi tələb olunur')
                    .test('phone-format', t.phone_invalid || 'Telefon nömrəsi düzgün formatda deyil', function (value) {
                    if (!value)
                        return true;
                    var digits = value.replace(/\D/g, '');
                    if (digits.length !== 12) {
                        return this.createError({
                            message: t.phone_invalid || 'Telefon nömrəsi tam daxil edilməlidir'
                        });
                    }
                    var operatorCode = digits.substring(3, 5);
                    var allowedCodes = ['10', '50', '51', '55', '70', '77', '99'];
                    if (!allowedCodes.includes(operatorCode)) {
                        return this.createError({
                            message: t.phone_operator_invalid || 'Operator kodu düzgün deyil (10, 50, 51, 55, 70, 77, 99)'
                        });
                    }
                    return true;
                }),
                docType: yup
                    .string()
                    .required()
            };
            if (this.isExtraRequired) {
                shape.firstName = yup.string().required('Ad tələb olunur');
                shape.lastName = yup.string().required('Soyad tələb olunur');
                shape.birthDate = yup
                    .string()
                    .required('Doğum tarixi tələb olunur')
                    .matches(/^\d{2}-\d{2}-\d{4}$/, 'Doğum tarixi düzgün deyil (DD-MM-YYYY)')
                    .test('is-valid-date', 'Doğum tarixi düzgün deyil', function (value) {
                    if (!value)
                        return true;
                    var parts = value.split('-');
                    if (parts.length !== 3)
                        return false;
                    var day = parseInt(parts[0], 10);
                    var month = parseInt(parts[1], 10);
                    var year = parseInt(parts[2], 10);
                    if (isNaN(day) || isNaN(month) || isNaN(year))
                        return false;
                    if (month < 1 || month > 12 || day < 1 || day > 31)
                        return false;
                    var d = new Date(year, month - 1, day);
                    var currentYear = new Date().getFullYear();
                    return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day && year <= currentYear && year >= currentYear - 100;
                });
            }
            return yup.object().shape(shape);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IcbariAutoValidationMixin.prototype, "step1CoreValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step1) || {};
            return yup.object().shape({
                registrationPlate: yup
                    .string()
                    .required(t.registration_plate_required || 'Qeydiyyat nişanı tələb olunur')
                    .matches(this.registrationPlatePattern, t.registration_plate_invalid || 'Qeydiyyat nişanı düzgün formatda deyil'),
                certificate: yup
                    .string()
                    .required(t.certificate_required || 'Qeydiyyat şəhadətnaməsi tələb olunur')
                    .matches(/^[A-Z]{2}\d{6,7}$/, t.certificate_invalid || 'Qeydiyyat şəhadətnaməsi düzgün formatda deyil'),
            });
        },
        enumerable: false,
        configurable: true
    });
    IcbariAutoValidationMixin.prototype.validateStep1Core = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1, errors_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.step1CoreValidationSchema.validate(this.stepsData.step1, { abortEarly: false })];
                    case 1:
                        _a.sent();
                        if (this.step1Errors) {
                            this.$delete(this.step1Errors, 'registrationPlate');
                            this.$delete(this.step1Errors, 'certificate');
                        }
                        return [2 /*return*/, true];
                    case 2:
                        err_1 = _a.sent();
                        errors_1 = __assign({}, (this.step1Errors || {}));
                        if (err_1.inner) {
                            err_1.inner.forEach(function (error) {
                                errors_1[error.path] = error.message;
                            });
                        }
                        this.step1Errors = errors_1;
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IcbariAutoValidationMixin.prototype.validateStep1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_2, errors_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.step1ValidationSchema.validate(this.stepsData.step1, { abortEarly: false })];
                    case 1:
                        _a.sent();
                        this.step1Errors = {};
                        return [2 /*return*/, true];
                    case 2:
                        err_2 = _a.sent();
                        errors_2 = {};
                        if (err_2.inner) {
                            err_2.inner.forEach(function (error) {
                                errors_2[error.path] = error.message;
                            });
                        }
                        this.step1Errors = errors_2;
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IcbariAutoValidationMixin.prototype.validateStep2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_3, errors_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.step2ValidationSchema.validate(this.stepsData.step2, { abortEarly: false })];
                    case 1:
                        _a.sent();
                        this.step2Errors = {};
                        return [2 /*return*/, true];
                    case 2:
                        err_3 = _a.sent();
                        errors_3 = {};
                        if (err_3.inner) {
                            err_3.inner.forEach(function (error) {
                                errors_3[error.path] = error.message;
                            });
                        }
                        this.step2Errors = errors_3;
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IcbariAutoValidationMixin.prototype.validateStep3 = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var t;
            return __generator(this, function (_b) {
                t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step3) || {};
                if (!this.stepsData.step3.selectedCompanyId) {
                    this.step3Errors = {
                        company: t.company_required || 'Sığorta şirkəti seçilməlidir'
                    };
                    return [2 /*return*/, false];
                }
                this.step3Errors = {};
                return [2 /*return*/, true];
            });
        });
    };
    IcbariAutoValidationMixin.prototype.validateCurrentStep = function (currentStep) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(currentStep === 1)) return [3 /*break*/, 2];
                        console.log('test');
                        return [4 /*yield*/, this.validateStep1()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!(currentStep === 2)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.validateStep2()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        if (!(currentStep === 3)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.validateStep3()];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6: return [2 /*return*/, true];
                }
            });
        });
    };
    IcbariAutoValidationMixin = __decorate([
        Component
    ], IcbariAutoValidationMixin);
    return IcbariAutoValidationMixin;
}(Vue));
export default IcbariAutoValidationMixin;
